<template>
  <div>
    <Form
      ref="chapterForm"
      :rules="ruleValidate"
      :model="chapterInfo"
      :label-width="120"
      @keydown.native.enter.prevent="() => {}"
    >
      <div class="title">基本信息</div>
      <FormItem label="课时名称" prop="title">
        <Input
          style="width: 300px"
          type="text"
          v-model="chapterInfo.title"
          placeholder="请输入课时名称，最多不超过50个字"
          :maxlength="50"
          clearable
        />
        <CharCount :max="50" :text="chapterInfo.title"></CharCount>
      </FormItem>
      <FormItem
        label="课程内容"
        prop="course_content"
        v-if="$route.query.course_type == 10"
      >
        <UEditor v-model="chapterInfo.course_content"></UEditor>
      </FormItem>

      <FormItem
        label="直播类型"
        prop="is_mock_live"
        v-if="$route.query.course_type == 2"
      >
        <RadioGroup v-model="chapterInfo.is_mock_live">
          <Radio :label="0" :disabled="$route.query.id > 0">
            <span>常规直播</span>
          </Radio>
          <Radio
            :label="1"
            :disabled="$route.query.id > 0 || is_divide_class > 0"
          >
            <span>
              伪直播
              <i v-if="is_divide_class > 0">(分组直播暂不支持)</i>
            </span>
          </Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        prop="mock_live_url"
        v-if="
          chapterInfo.is_mock_live == 1 &&
          chapterInfo.cloud_class_type == 'plaso'
        "
      >
        <input ref="file" type="file" />
        <Button icon="ios-add" @click="uploadOSS">上传</Button>
        <Progress :percent="uploadOSSProgress" v-if="uploadOSSProgress > 0" />
        <iframe
          v-if="chapterInfo.mock_live_url"
          :src="chapterInfo.mock_live_url"
          width="200px"
          height="150px"
        />
      </FormItem>

      <FormItem
        prop="is_mock_live"
        v-if="
          chapterInfo.is_mock_live == 1 &&
          chapterInfo.cloud_class_type == 'baijiayun'
        "
        label="伪直播视频方式"
      >
        <RadioGroup v-model="chapterInfo.video_type">
          <Radio :label="0">
            <span>上传视频</span>
          </Radio>
          <Radio :label="1">
            <span>手动输入视频ID</span>
          </Radio>
          <Radio :label="2">
            <span>手动输入回放教室ID</span>
          </Radio>
        </RadioGroup>
      </FormItem>

      <div
        class="video-upload"
        v-show="
          $route.query.course_type == 5 ||
          $route.query.course_type == 8 ||
          ($route.query.course_type == 2 &&
            chapterInfo.is_mock_live > 0 &&
            chapterInfo.cloud_class_type == 'baijiayun')
        "
      >
        <FormItem
          prop="video_id"
          v-if="
            chapterInfo.video_type == 1 &&
            chapterInfo.cloud_class_type == 'baijiayun'
          "
          label="视频ID"
        >
          <Input
            type="text"
            style="width: 200px"
            placeholder="请输入视频ID"
            v-model="chapterInfo.video_id"
          ></Input>
        </FormItem>

        <FormItem
          prop="mock_room_id"
          v-else-if="
            chapterInfo.video_type == 2 &&
            chapterInfo.cloud_class_type == 'baijiayun'
          "
          label="回放教室"
        >
          <Input
            type="text"
            style="width: 200px"
            placeholder="请输入回放教室ID"
            v-model="chapterInfo.mock_room_id"
          ></Input>
        </FormItem>

        <FormItem
          prop="video_id"
          v-else
          :label="
            $route.query.course_type == 5 ||
            ($route.query.course_type == 2 &&
              chapterInfo.cloud_class_type == 'baijiayun')
              ? '点播视频'
              : '音频文件'
          "
        >
          <span>{{ chapterInfo.video_id }}</span>
          <Button
            icon="ios-add"
            style="margin-left: 4px"
            @click.native="uploadVideo"
          >
            选择文件
          </Button>
          <span class="sm-title" style="margin-left: 4px">
            {{
              $route.query.course_type == 5 || $route.query.course_type == 2
                ? "支持MP4/FLV/AVI/WMV/3GP/MKV/RMVB格式的视频"
                : "支持MP3/M4A、WMA/WAV格式的音频"
            }}
          </span>
          <input id="video_file" type="file" v-show="false" />
          <span id="upload_tips" style="color: red"></span>
        </FormItem>

        <FormItem
          prop="mock_live_record"
          label="自动录制回放"
          v-if="chapterInfo.is_mock_live > 0"
        >
          <RadioGroup v-model="chapterInfo.mock_live_record">
            <Radio :label="0" :disabled="$route.query.id > 0">
              <span>否</span>
            </Radio>
            <Radio :label="1" :disabled="$route.query.id > 0">
              <span>是</span>
            </Radio>
          </RadioGroup>
          <span class="sm-title" style="margin-left: 4px">
            自动录制不支持编辑
          </span>
        </FormItem>
      </div>

      <FormItem
        label="开课时间"
        prop="playTimeRange"
        v-if="
          $route.query.course_type != 5 &&
          $route.query.course_type != 8 &&
          $route.query.course_type != 10
        "
      >
        <DatePicker
          type="datetime"
          placeholder="选择开始时间"
          v-model="chapterInfo.playTimeRange[0]"
          @on-change="playTimeRangeChange"
          format="yyyy-MM-dd HH:mm"
          style="width: 200px"
          :editable="false"
        ></DatePicker>
        <span>~</span>
        <DatePicker
          type="datetime"
          placeholder="选择结束时间"
          v-model="chapterInfo.playTimeRange[1]"
          @on-change="playTimeRangeChange"
          format="yyyy-MM-dd HH:mm"
          style="width: 200px"
          :editable="false"
        ></DatePicker>
      </FormItem>

      <FormItem
        v-if="
          $route.query.course_type != 5 &&
          $route.query.course_type != 8 &&
          $route.query.course_type != 10
        "
        label="云课堂类型"
        prop="cloud_class_type"
      >
        <Select
          :disabled="$route.query.id > 0"
          v-model="chapterInfo.cloud_class_type"
          style="width: 100px"
        >
          <Option value="plaso">伯索云</Option>
          <Option value="baijiayun">百家云</Option>
        </Select>
      </FormItem>

      <FormItem
        label="授课讲师"
        prop="teacher_id"
        v-if="$route.query.course_type != 10 && $route.query.course_type != 7"
      >
        <Select v-model="chapterInfo.teacher_id" style="width: 300px">
          <Option
            v-for="tea in teachers"
            :value="tea.teacher_id.toString()"
            :key="tea.teacher_id"
            >{{ tea.teacher_name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem
        label="授课讲师"
        prop="teacher_ids"
        v-if="$route.query.course_type == 7"
      >
        <CheckboxGroup v-model="chapterInfo.teacher_ids">
          <Checkbox
            :label="tea.teacher_id"
            :key="tea.teacher_id"
            v-for="tea in teachers"
            >{{ tea.teacher_name }}</Checkbox
          >
        </CheckboxGroup>
      </FormItem>

      <FormItem label="讲义">
        <div>
          <div v-for="(item, index) in chapterInfo.files" :key="index">
            <a v-if="item.file_url" target="_blank" :href="item.file_url">{{
              item.file_name
            }}</a>
            <a
              @click="chapterInfo.files.splice(index, 1)"
              style="margin-left: 20px; color: #999"
              >删除</a
            >
          </div>
        </div>
        <Upload
          ref="upload"
          :action="baseUrl + '/api/public/file'"
          :before-upload="beforeUpload"
          :show-upload-list="showUploadList"
          :headers="header"
          :on-success="successHanlder"
          :on-format-error="onFormatError"
          :format="['pdf', 'doc', 'ppt', 'xlsx', 'txt']"
          style="width: 550px"
        >
          <Button icon="ios-add">选择文件</Button>
          <template v-slot:tip>
            <span class="sm-title"
              >支持PDF/DOC/PPT/XLSX/TXT格式的文档，可用于课前预习或者课后复习</span
            >
          </template>
        </Upload>
      </FormItem>
      <FormItem
        label="是否支持查看回放"
        v-if="
          $route.query.course_type != 5 &&
          $route.query.course_type != 8 &&
          $route.query.course_type != 10 &&
          $route.query.course_type != 7
        "
      >
        <RadioGroup v-model="chapterInfo.is_playback">
          <Radio :label="0">
            <span>否</span>
          </Radio>
          <Radio :label="1">
            <span>是</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="是否试看" v-if="$route.query.course_type != 7">
        <RadioGroup v-model="chapterInfo.is_try_see">
          <Radio :label="0">
            <span>否</span>
          </Radio>
          <Radio :label="1">
            <span>是</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="提前进入教室时间" v-if="$route.query.course_type == 2">
        <RadioGroup v-model="beforeEnterTime">
          <Radio :label="0">
            <span>任意时间</span>
          </Radio>
          <Radio :label="1">
            <span>提前</span>
          </Radio>
        </RadioGroup>
        <span v-if="beforeEnterTime == 1">
          <Input
            v-model="chapterInfo.advance_time"
            type="number"
            :min="1"
            style="width: 50px"
          />分钟才可进入教室
        </span>
      </FormItem>
      <FormItem style="text-align: center">
        <Button
          size="large"
          :to="{
            name: 'CoursePlan',
            query: { id: this.$route.query.course_id },
          }"
        >
          返回
        </Button>
        <Button
          size="large"
          style="margin: 0 15px"
          type="primary"
          :disabled="canClick"
          @click="submitForm('chapterForm')"
        >
          保存并返回
        </Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
const buildConfig = require("../../build/" + process.env.BUILD_ENV + ".js");
import UEditor from "@/components/UEditor.vue";
import OSS from "ali-oss";

export default {
  name: "CourseChapter",
  components: {
    UEditor,
  },
  data() {
    return {
      isShowOSSProgress: false,
      uploadOSSProgress: 0,
      file: null,
      loadingStatus: false,
      canClick: false,
      baseUrl: buildConfig.BASE_URL,
      header: {
        Authorization: "Bearer " + localStorage.adminToken,
      },
      showUploadList: false,
      beforeEnterTime: 0,
      chapterInfo: {
        title: "",
        start_play: "",
        end_play: "",
        teacher_id: "",
        file_url: "",
        file_name: "",
        is_playback: 1,
        is_try_see: 0,
        sort: 0,
        room_video_id: "",
        mock_video_id: "",
        video_id: "",
        course_content: "",
        teacher_ids: [],
        playTimeRange: ["", ""],
        files: [],
        video_type: 0,
        mock_room_id: "",
        is_mock_live: 0,
        mock_live_record: 1,
        advance_time: 0,
        cloud_class_type: "plaso",
        mock_live_url: "",
      },
      is_divide_class: 0,
      teachers: [],
      ruleValidate: {
        title: [
          {
            required: true,
            message: "课时名称不能为空",
            trigger: "blur",
          },
        ],
        playTimeRange: [
          {
            required: true,
            trigger: "change",
            validator: (_rule, value, callback) => {
              if (value[0] == "") {
                callback(new Error("开始时间不能为空"));
              } else if (value[1] == "") {
                callback(new Error("结束时间不能为空"));
              } else {
                callback();
              }
            },
          },
        ],
        teacher_id: [
          {
            required: true,
            message: "授课讲师不能为空",
            trigger: "change",
          },
        ],
        is_mock_live: [
          {
            required: true,
            trigger: "change",
            validator: (_rule, value, callback) => {
              if (this.$route.query.course_type == 2 && value === "") {
                callback(new Error("直播类型不能为空"));
              } else {
                callback();
              }
            },
          },
        ],
        mock_live_record: [
          {
            required: true,
            trigger: "change",
            validator: (_rule, value, callback) => {
              if (
                this.chapterInfo.is_mock_live > 0 &&
                value === "" &&
                this.chapterInfo.cloud_class_type === "baijiayun"
              ) {
                callback(new Error("自动录制回放不能为空"));
              } else {
                callback();
              }
            },
          },
        ],
        video_id: [
          {
            required: true,
            trigger: "change",
            validator: (_rule, value, callback) => {
              if (
                (this.$route.query.course_type == 5 ||
                  this.$route.query.course_type == 8) &&
                value == "" &&
                this.chapterInfo.cloud_class_type === "baijiayun"
              ) {
                callback(new Error("点播视频不能为空"));
              } else if (
                this.chapterInfo.is_mock_live > 0 &&
                this.chapterInfo.video_type != 2 &&
                value == "" &&
                this.chapterInfo.cloud_class_type === "baijiayun"
              ) {
                callback(new Error("视频不能为空"));
              } else {
                callback();
              }
            },
          },
        ],
        mock_room_id: [
          {
            required: true,
            validator: (_rule, value, callback) => {
              if (
                this.chapterInfo.is_mock_live > 0 &&
                this.chapterInfo.video_type == 2 &&
                value == "" &&
                this.chapterInfo.cloud_class_type === "baijiayun"
              ) {
                callback(new Error("回放教室不能为空"));
              } else {
                callback();
              }
            },
          },
        ],
        course_content: [
          {
            required: true,
            message: "课程内容不能为空",
            trigger: "change",
          },
        ],
        teacher_ids: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "授课讲师不能为空",
            trigger: "change",
          },
        ],
      },
    };
  },
  async created() {
    let data = await this.$http.get(
      "/api/course/basis/" + this.$route.query.course_id
    );
    this.teachers = data.course_teacher;
    this.is_divide_class = data.is_divide_class;
    if (!this.$route.query.id) {
      this.beforeEnterTime = data.advance_time > 0 ? 1 : 0;
      this.chapterInfo.advance_time = data.advance_time;
    }
    await this.getChapterInfo();
  },
  mounted() {
    let self = this;
    let video_id;
    this.$nextTick(function () {
      if (
        self.$route.query.course_type != 8 &&
        self.$route.query.course_type != 5 &&
        self.$route.query.course_type != 2
      ) {
        return;
      }
      let accept;
      if (self.$route.query.course_type == 8) {
        accept = ["mp3", "wma", "wav", "m4a"];
      }
      let $ = window.$;
      let uploader = new window.BJY.VideoUploader({
        mainElement: $("#video_file"),
        ignoreError: true,
        name: "",
        accept: accept,
        multiple: true,
        getUploadUrl: function (data) {
          return $.ajax({
            url:
              self.baseUrl +
              "/api/public/bjyUploadVideo" +
              (self.$route.query.course_type == 8 ? "?audio_with_view=1" : ""),
            type: "post",
            beforeSend: function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + localStorage.adminToken
              );
            },
            data: {
              title: self.chapterInfo.title,
              file_name: data.videoName,
            },
          }).then(function (response) {
            let result = response.data;
            if (response.code != 200) {
              self.$Message.error(response.msg);
            } else {
              video_id = result.video_id;
              return {
                id: self.chapterInfo.room_video_id,
                url: result.upload_url.replace("http:", location.protocol),
              };
            }
          });
        },
        getResumeUploadUrl: function (data) {
          return $.ajax({
            url: self.baseUrl + "/api/public/bjyResumeUploadVideo",
            type: "post",
            beforeSend: function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + localStorage.adminToken
              );
            },
            data: {
              room_video_id: data.uploadId,
            },
          }).then(function (response) {
            var result = response.data;
            if (!result) {
              alert(response.msg);
              return;
            }
            return {
              fid: result.video_id,
              id: result.video_id,
              url: result.upload_url.replace("http:", location.protocol),
              uploaded: result.upload_size,
            };
          });
        },
        onFileChange: function () {
          var currentFiles = uploader.currentFiles;
          if (!currentFiles.length) {
            return;
          }

          if (!uploader.validateFiles(currentFiles)) {
            uploader.reset();
            return;
          }
          var itemHTML = '<div class="item-list">';

          $.each(currentFiles, function (_index, file) {
            itemHTML +=
              '<div class="item">' +
              '<span class="item-text item-name">' +
              file.videoName +
              "</span>" +
              '<span class="item-text item-status">等待上传</span>' +
              " </div>";
            uploader.autoUpload(file);
          });

          itemHTML += "</div>";
          $(itemHTML).insertAfter($(".bjy-demo"));
        },
        onUploadStart: function () {
          $("#upload_tips").html("正在上传请稍后...");
        },
        onUploadProgress: function (data) {
          $("#upload_tips").html("上传" + data.percent);
        },
        onUploadSuccess: function () {
          $("#upload_tips").html("上传成功");
          self.chapterInfo.video_id = video_id.toString();
        },
        onChunkUploadError: function () {
          self.$Message.error("上传错误，请重新上传");
        },
        onUploadError: function (data) {
          self.$Message.error("上传错误，请重新上传");
          $(".item")
            .eq(data.fileItem.index)
            .find(".item-status")
            .html("上传失败");
        },
        onUploadComplete: function () {},
        onError: function (data) {
          self.$Message.error(data.content);
        },
      });
    });
  },
  methods: {
    uuid() {
      function func() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }

      return (
        func() +
        func() +
        "-" +
        func() +
        "-3" +
        func().substr(0, 2) +
        "-" +
        func() +
        "-" +
        func() +
        func() +
        func()
      ).toLowerCase();
    },
    async uploadOSS() {
      try {
        this.chapterInfo.mock_live_url = "";

        const result = await this.$http.get("/api/sts");
        const options = {
          // 获取分片上传进度、断点和返回值。
          progress: (p) => {
            this.uploadOSSProgress = p * 100;
          },
          // 设置并发上传的分片数量。
          parallel: 4,
          // 设置分片大小。默认值为1 MB，最小值为100 KB。
          partSize: 1024 * 1024,
        };
        const client = new OSS({
          accessKeyId: result.accessKeyId,
          accessKeySecret: result.accessKeySecret,
          stsToken: result.securityToken,
          region: "oss-cn-hangzhou",
          bucket: "zgmedia",
          refreshSTSTokenInterval: 5 * 60 * 1000,
          refreshSTSToken: async () => {
            const info = await this.$http.get("/api/sts");
            return {
              accessKeyId: info.accessKeyId,
              accessKeySecret: info.accessKeySecret,
              stsToken: info.securityToken,
            };
          },
        });
        const data = this.$refs.file.files[0];
        const fileName = data.name;
        // 分片上传。
        await client.multipartUpload(fileName, data, {
          ...options,
        });
        this.chapterInfo.mock_live_url = `https://media.zhanggongedu.com/${fileName}`;
      } catch (err) {
        this.$Message.error(`上传失败: ${err}`);
        console.log(err);
      }
    },

    async getChapterInfo() {
      let id = this.$route.query.id;
      if (!id) {
        return;
      }
      let chapterInfo = await this.$http.get("/api/course/chapter/info/" + id);
      this.chapterInfo.title = chapterInfo.title;
      let range = [];
      range.push(new Date(chapterInfo.start_play * 1000));
      range.push(new Date(chapterInfo.end_play * 1000));
      this.chapterInfo.playTimeRange = range;
      this.chapterInfo.start_play = range[0].format("yyyy-MM-dd hh:mm");
      this.chapterInfo.end_play = range[1].format("yyyy-MM-dd hh:mm");
      this.chapterInfo.is_playback = chapterInfo.is_playback;
      this.chapterInfo.is_try_see = chapterInfo.is_try_see;
      if (chapterInfo.teacher_info && chapterInfo.teacher_info.length > 0) {
        if (this.$route.query.course_type == 7) {
          let ids = [];
          chapterInfo.teacher_info.forEach((t) => {
            ids.push(t.teacher_id);
          });
          this.chapterInfo.teacher_ids = ids;
        } else {
          this.chapterInfo.teacher_id =
            chapterInfo.teacher_info[0].teacher_id.toString();
        }
      }
      if (chapterInfo.course_datum && chapterInfo.course_datum.file_name) {
        let files = [];
        if (chapterInfo.course_datum.file_name instanceof Array) {
          for (let i = 0; i < chapterInfo.course_datum.file_name.length; i++) {
            files.push({
              file_url: chapterInfo.course_datum.file_url[i],
              file_name: chapterInfo.course_datum.file_name[i],
            });
          }
        } else {
          files.push({
            file_url: chapterInfo.course_datum.file_url,
            file_name: chapterInfo.course_datum.file_name,
          });
        }
        this.chapterInfo.files = files;
      }
      this.chapterInfo.room_video_id = chapterInfo.room_video_id;
      this.chapterInfo.course_content = chapterInfo.course_content;
      if (chapterInfo.mock_video_id > 0 || chapterInfo.mock_room_id > 0) {
        if (chapterInfo.mock_video_id > 0) {
          this.chapterInfo.mock_video_id = chapterInfo.mock_video_id;
          this.chapterInfo.video_id = chapterInfo.mock_video_id;
          this.chapterInfo.video_type = 0;
        }
        if (chapterInfo.mock_room_id > 0) {
          this.chapterInfo.mock_room_id = chapterInfo.mock_room_id;
          this.chapterInfo.video_type = 2;
        }
        this.chapterInfo.mock_live_record = chapterInfo.mock_live_record;
        this.chapterInfo.is_mock_live = 1;
      }
      if (
        this.$route.query.course_type == 5 ||
        this.$route.query.course_type == 8
      ) {
        this.chapterInfo.video_id = chapterInfo.room_video_id;
      }
      this.beforeEnterTime = chapterInfo.advance_time > 0 ? 1 : 0;
      this.chapterInfo.advance_time = chapterInfo.advance_time;
    },
    playTimeRangeChange() {
      let playTimeRange = this.chapterInfo.playTimeRange;
      if (playTimeRange[0] == "") {
        this.chapterInfo.start_play = "";
        this.chapterInfo.end_play = "";
      } else {
        this.chapterInfo.start_play =
          playTimeRange[0].format("yyyy-MM-dd hh:mm");
        this.chapterInfo.end_play = playTimeRange[1].format("yyyy-MM-dd hh:mm");
      }
    },
    beforeUpload() {
      this.showUploadList = true;
    },
    successHanlder(response) {
      if (response.code == 201) {
        this.$Message.error(response.msg);
        this.$refs.upload.clearFiles();
      } else {
        this.showUploadList = false;
        this.chapterInfo.files.push({
          file_url: response.data.path,
          file_name: response.data.originalName,
        });
      }
    },
    onUploadVideoSuccess(response) {
      if (response.code == 201) {
        this.$Message.error(response.msg);
        this.$refs.uploadVideo.clearFiles();
      } else {
        this.chapterInfo.mock_live_url = response.data.path;
      }
    },
    submitForm(ref) {
      this.canClick = true;
      this.$refs[ref].validate(async (valid) => {
        if (!valid) {
          this.canClick = false;
          return;
        }

        if (
          this.chapterInfo.is_mock_live > 0 &&
          this.chapterInfo.cloud_class_type === "plaso" &&
          !this.chapterInfo.mock_live_url
        ) {
          this.$Message.warning("请先上传伪直播视频文件");
          this.canClick = false;
          return;
        }

        let data = {};
        let id = this.$route.query.id;
        data.title = this.chapterInfo.title;
        data.course_basis_id = this.$route.query.course_id;
        data.parent_id = this.$route.query.parent_id;
        if (id) {
          data.id = id;
          data.sort = this.chapterInfo.sort;
        } else {
          data.sort = 0;
        }
        data.course_type = this.$route.query.course_type;
        if (this.$route.query.course_type == 7) {
          data.teacher_id = this.chapterInfo.teacher_ids.join(",");
        } else {
          data.teacher_id = this.chapterInfo.teacher_id;
        }
        data.start_play = this.chapterInfo.start_play;
        data.end_play = this.chapterInfo.end_play;
        data.is_playback = this.chapterInfo.is_playback;
        data.is_try_see = this.chapterInfo.is_try_see;
        data.cloud_class_type = this.chapterInfo.cloud_class_type;
        let fileUrls = [],
          fileNames = [];
        this.chapterInfo.files.forEach((f) => {
          fileUrls.push(f.file_url);
          fileNames.push(f.file_name);
        });
        data.file_url = fileUrls.join(";");
        data.file_name = fileNames.join(";");
        data.mock_live_url = this.chapterInfo.mock_live_url;
        data.room_video_id = this.chapterInfo.room_video_id;
        data.is_mock_live = this.chapterInfo.is_mock_live;
        if (data.is_mock_live > 0) {
          if (this.chapterInfo.video_type == 2) {
            data.mock_room_id = this.chapterInfo.mock_room_id;
          } else {
            data.mock_video_id = this.chapterInfo.video_id;
          }
          data.video_type = this.chapterInfo.video_type;
          data.mock_live_record = this.chapterInfo.mock_live_record;
        }
        if (
          this.$route.query.course_type == 5 ||
          this.$route.query.course_type == 8
        ) {
          data.room_video_id = this.chapterInfo.video_id;
        }
        data.course_content = this.chapterInfo.course_content;
        data.advance_time =
          this.beforeEnterTime > 0 ? this.chapterInfo.advance_time : 0;
        let _this = this;
        setTimeout(function () {
          _this.canClick = false;
        }, 1000);
        if (!id) {
          await this.$http.post("/api/course/chapter", data);
        } else {
          await this.$http.put("/api/course/chapter", data);
        }
        this.$router.push({
          name: "CoursePlan",
          query: { id: this.$route.query.course_id },
        });
      });
    },
    uploadVideo(event) {
      if (this.chapterInfo.title == "") {
        event.preventDefault();
        this.$Message.warning("请输入课时名称");
        return;
      }
      window.$("#video_file").click();
    },
    onFormatError() {
      this.$Message.error("文件格式错误");
    },
  },
};
</script>
<style lang="scss" scoped>
.sm-title {
  color: #ccc;
  font-size: 12px;
}
</style>
